import React, {useEffect, useState} from "react"
import { Div, Text, Container, Row, Col } from "atomize";
import styled from "styled-components";
import Header from "../Components/Molecules/Header";
import Routes from "../Routes";
import {apiGet} from "../Api";
import GrayBg from "./../Components/Atoms/GrayBg";
import Toggle from "../Components/Atoms/Toggle";
import StoriesCard, {LoadingStoriesCard} from "../Components/Molecules/StoriesCard";
import StoriesPromptCard from "../Components/Molecules/StoriesPromptCard";
// import Select from 'react-select';
import MapView from "../Components/Molecules/MapView";
import makeAnimated from 'react-select/animated';
// import {selectStyles} from "../Components/Atoms/Select";
import theme from "../Theme/Theme";
import SEO from "../Components/Atoms/SEO";
import ReactGA from "react-ga";

const animatedComponents = makeAnimated();

const StyledCol= styled(Col)`
  > div {
    margin-bottom: 1rem;
  }
  justify-content: center;
  display: flex;
`;

const StyledRow = styled(Row)`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

const Label = styled.label`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  color: ${theme.colors.dark};
  letter-spacing: 0;
  line-height: 30px;
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const Arr = [1,2,3];

function Stories(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);

  // const [orgOptions, setOrgOptions] = useState([]);
  const [orgs, setOrgs] = useState(null);
  const [data, setData] = useState({});
  const [stories, setStories] = useState(null);
  const [heroImgUrl, setHeroImgUrl] = useState(null);
  const [view, setView] = useState(0);

  const page = Routes.filter( route => {
    return route.path === props.location.pathname
  });

  let pageTitle = '';

  if (page.length > 0) {
    pageTitle = page[0].name;
  }

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/page?filter[title]=${pageTitle}&include=field_banner_image`);
      setData(result.data);
      setHeroImgUrl(result.data.included[0].attributes.uri.url);

      let storiesResult = await apiGet(`/node/story?include=field_banner_image&jsonapi_include=1`);
      storiesResult = storiesResult.data.data;
      // setStories( storiesResult.data.data);

      let storiesQueResult = await apiGet(`/entity_subqueue/stories_queue?jsonapi_include=1`);
      storiesQueResult = storiesQueResult.data.data[0].items;

      storiesResult.sort((a, b) => {
        a = storiesQueResult.findIndex( s => s.id === a.id);
        b = storiesQueResult.findIndex( s => s.id === b.id);
        return a-b
      });

      setStories(storiesResult);

      const orgsResult = await apiGet(`/taxonomy_term/organizations?jsonapi_include=1`);
      setOrgs( orgsResult.data.data );

      // let options = [];
      // orgsResult.data.data.forEach( org => {
      //   options.push({ value: org.id, label: org.name })
      // });
      // setOrgOptions(options)
    }
    fetchData();

  }, []);

  return (
    <Div>
      <SEO
        title={"Stories | Engineering for Humanity | Olin College of Engineering"}
        description={data && data.field_description ? data.field_description : null}
      />
      <Header
        pageTitle={pageTitle}
        heroImgUrl={heroImgUrl}
      />
      <GrayBg>
        <Container>
          <Row
            p={{y: '1.5rem'}}
          >
            <Col>
              {/*<Label>Organization</Label>*/}
              {/*<Select*/}
                {/*className="select-org"*/}
                {/*classNamePrefix="select"*/}
                {/*// defaultValue={orgOptions[0]}*/}
                {/*placeholder={'Filter by organizations...'}*/}
                {/*isDisabled={false}*/}
                {/*isLoading={false}*/}
                {/*isClearable={true}*/}
                {/*isRtl={false}*/}
                {/*isSearchable={true}*/}
                {/*isMulti={true}*/}
                {/*name="orgs"*/}
                {/*options={orgOptions}*/}
                {/*components={animatedComponents}*/}
                {/*styles={selectStyles}*/}
              {/*/>*/}
            </Col>
            <Col>
              <ViewWrapper>
                <Label>View</Label>
                <Toggle
                  action={ (e) => setView(e)}
                />
              </ViewWrapper>
            </Col>
          </Row>
        </Container>
      </GrayBg>
      <Container>
        {
          view === 0 &&
          <StyledRow>
            <StyledCol
              size={{ xs: '12', sm: '12', md: '6', lg: '4' }}
            >
              <StoriesPromptCard />
            </StyledCol>
            {
              !stories &&
                Arr.map( a => {
                  return (
                    <StyledCol
                      key={a}
                      size={{ xs: '12', sm: '12', md: '6', lg: '4' }}
                    >
                      <LoadingStoriesCard/>
                    </StyledCol>
                  )
                })
            }
            {
              stories && stories.map( (story, i) => {
                return (
                  <StyledCol
                    key={story.id+ i}
                    size={{ xs: '12', sm: '12', md: '6', lg: '4' }}
                  >
                    <StoriesCard
                      id={story.id}
                      title={story.title}
                      story={story}
                    />
                  </StyledCol>
                )
              })
            }
          </StyledRow>
        }
        {
          view === 1 &&
            <MapView
              orgs={orgs}
              stories={stories}
            />
        }
      </Container>
    </Div>
  )
}

export default Stories
